/**
 * assets/pfeifentabak.js
 * No 7 Augsburg - Pfeifentabak-Landingpage
 * - Grundpreisberechnung (EUR / 1 kg) aus Varianten- oder Produkttitel
 * - Alle Varianten als separate Zeilen; kein Mengenrabatt
 * - Cart-Drawer via fetch('/cart') + sidebar-drawer#site-cart-sidebar
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     Grundpreis: Gewicht aus einem Titelstring extrahieren
     Erkennt: "50g", "(50g)", "100 g", "0,5kg", "(200g Dose)" usw.
  ───────────────────────────────────────────────────────────── */
  window.n7ptParseWeightKg = function (str) {
    if (!str) return 0;
    /* Suche nach Muster: Zahl (optional Komma/Punkt) optional Leerzeichen dann g oder kg */
    var m = String(str).match(/(\d+[.,]?\d*)\s*(kg|g)\b/i);
    if (!m) return 0;
    var val = parseFloat(m[1].replace(',', '.'));
    if (isNaN(val) || val <= 0) return 0;
    /* g → durch 1000; kg bleibt */
    return m[2].toLowerCase() === 'g' ? val / 1000 : val;
  };

  window.n7ptFormatMoney = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  };

  window.n7ptFormatBasePrice = function (cents, weightKg) {
    if (!weightKg || weightKg <= 0) return '';
    var perKg = (cents / 100) / weightKg;
    return perKg.toFixed(2).replace('.', ',') + '\u00a0\u20ac\u00a0/\u00a01\u00a0kg';
  };

  /* ─────────────────────────────────────────────────────────────
     Grundpreise in alle Varianten-Zeilen rendern
     Gewicht: zuerst aus Varianten-Titel, Fallback Produkt-Titel
  ───────────────────────────────────────────────────────────── */
  window.n7ptRenderBasePrices = function () {
    var rows = document.querySelectorAll('.n7pt-row');
    for (var ri = 0; ri < rows.length; ri++) {
      var row       = rows[ri];
      var prodTitle = row.getAttribute('data-title') || '';
      var varRows   = row.querySelectorAll('.n7pt-variant-row');

      for (var vi = 0; vi < varRows.length; vi++) {
        var vr           = varRows[vi];
        var varTitle     = vr.getAttribute('data-variant-title') || '';
        var priceCents   = parseInt(vr.getAttribute('data-price') || '0', 10);

        /* Gewicht: Varianten-Titel hat Vorrang (z.B. "50g Dose"), dann Produkt-Titel */
        var weightKg = window.n7ptParseWeightKg(varTitle);
        if (!weightKg) weightKg = window.n7ptParseWeightKg(prodTitle);

        var baseEl = vr.querySelector('.n7pt-base-price');
        if (baseEl) {
          baseEl.textContent = window.n7ptFormatBasePrice(priceCents, weightKg);
        }
      }
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Menge einer Varianten-Zeile ermitteln
  ───────────────────────────────────────────────────────────── */
  window.n7ptGetQty = function (variantId) {
    var input = document.getElementById('n7pt-qty-' + variantId);
    if (!input) return 1;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    return q;
  };

  /* ─────────────────────────────────────────────────────────────
     Cart Drawer
  ───────────────────────────────────────────────────────────── */
  window.n7ptOpenCartDrawer = function () {
    var triggers = document.querySelectorAll('[aria-controls="site-cart-sidebar"]');
    for (var i = 0; i < triggers.length; i++) {
      var rect = triggers[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        triggers[i].click();
        return true;
      }
    }
    var sidebarEl = document.querySelector('sidebar-drawer#site-cart-sidebar');
    if (sidebarEl && typeof sidebarEl.show === 'function') {
      sidebarEl.show();
      return true;
    }
    return false;
  };

  window.n7ptUpdateCartDrawer = function () {
    return fetch('/cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser      = new DOMParser();
        var doc         = parser.parseFromString(html, 'text/html');
        var fetchedCart = doc.querySelector('sidebar-drawer#site-cart-sidebar');
        var sidebarEl   = document.querySelector('sidebar-drawer#site-cart-sidebar');

        if (sidebarEl && fetchedCart) {
          /* sidebar__body: Artikel-Liste */
          var newBody  = fetchedCart.querySelector('.sidebar__body');
          var bodyEl   = sidebarEl.querySelector('.sidebar__body');
          if (bodyEl && newBody) bodyEl.innerHTML = newBody.innerHTML;

          /* sidebar__footer: Gesamtbetrag (AjaxCartSubtotal) */
          var newFooter = fetchedCart.querySelector('.sidebar__footer');
          var footerEl  = sidebarEl.querySelector('.sidebar__footer');
          if (footerEl && newFooter) footerEl.innerHTML = newFooter.innerHTML;

          /* sidebar__header: Warenkorb-Zähler im Drawer */
          var newHeader = fetchedCart.querySelector('.sidebar__header');
          var headerEl  = sidebarEl.querySelector('.sidebar__header');
          if (headerEl && newHeader) headerEl.innerHTML = newHeader.innerHTML;

          /* cart-form re-initialisieren falls vorhanden */
          var cartForm = sidebarEl.querySelector('cart-form');
          if (cartForm && typeof cartForm.ajaxifyCartItems === 'function') {
            cartForm.ajaxifyCartItems();
          }
        }

        /* Header-Button ausserhalb des Drawers aktualisieren (Menge + Preis) */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var totalFormatted = (cart.total_price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
              el.textContent = totalFormatted;
            });
          });

        window.n7ptOpenCartDrawer();
      })
      .catch(function (err) {
        console.warn('[n7pt] Cart-Drawer-Fehler:', err);
      });
  };

  /* ─────────────────────────────────────────────────────────────
     Event-Handler (delegiert auf #n7-pfeifentabak-page)
  ───────────────────────────────────────────────────────────── */
  window.n7ptBindEvents = function () {
    var page = document.getElementById('n7-pfeifentabak-page');
    if (!page || page.getAttribute('data-n7pt-bound') === '1') return;
    page.setAttribute('data-n7pt-bound', '1');

    page.addEventListener('click', function (e) {

      /* Mengen-Buttons */
      var qtyBtn = e.target.closest('.n7pt-qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var wrap  = qtyBtn.closest('.n7pt-qty-wrap');
        var input = wrap ? wrap.querySelector('.n7pt-qty-input') : null;
        if (!input) return;
        var cur    = parseInt(input.value, 10);
        if (isNaN(cur) || cur < 1) cur = 1;
        var action = qtyBtn.getAttribute('data-qty-action');
        if (action === 'plus')            cur += 1;
        if (action === 'minus' && cur > 1) cur -= 1;
        input.value = cur;
        return;
      }

      /* Mehr lesen */
      var rm = e.target.closest('.n7pt-intro__readmore');
      if (rm) {
        e.preventDefault();
        var desc = document.getElementById('n7pt-intro-desc');
        if (!desc) return;
        var expanded = desc.classList.toggle('n7pt-intro__desc--expanded');
        rm.innerHTML = expanded ? 'Weniger anzeigen \u2039' : 'Mehr lesen \u203a';
        return;
      }

      /* In den Warenkorb */
      var btn = e.target.closest('.n7pt-add-cart-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var qty = window.n7ptGetQty(variantId);

      btn.classList.add('n7pt-loading');
      var origLabel = btn.textContent;
      btn.textContent = 'Wird hinzugef\u00fcgt\u2026';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (e) {
              throw new Error(e.description || 'cart/add.js ' + r.status);
            });
          }
          return r.json();
        })
        .then(function () {
          btn.classList.remove('n7pt-loading');
          btn.classList.add('n7pt-added');
          btn.textContent = 'Hinzugef\u00fcgt \u2714';
          window.n7ptUpdateCartDrawer();
          setTimeout(function () {
            btn.classList.remove('n7pt-added');
            btn.textContent = 'In den Warenkorb';
          }, 2200);
        })
        .catch(function (err) {
          console.warn('[n7pt] cart/add.js Fehler:', err);
          btn.classList.remove('n7pt-loading');
          btn.textContent = origLabel || 'In den Warenkorb';
        });
    });

    /* Direkte Eingabe ins Mengenfeld */
    page.addEventListener('input', function (e) {
      var input = e.target.closest('.n7pt-qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) input.value = 1;
    });
  };

  /* ─────────────────────────────────────────────────────────────
     Mehr-lesen Button
  ───────────────────────────────────────────────────────────── */
  window.n7ptSetupReadmore = function () {
    var desc = document.getElementById('n7pt-intro-desc');
    var btn  = document.getElementById('n7pt-readmore');
    if (!desc || !btn) return;
    if (desc.scrollHeight <= desc.clientHeight + 4) {
      btn.style.display = 'none';
      desc.classList.add('n7pt-intro__desc--expanded');
    } else {
      btn.style.display = '';
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Init
  ───────────────────────────────────────────────────────────── */
  window.n7ptInit = function () {
    if (!document.getElementById('n7-pfeifentabak-page')) return;
    window.n7ptRenderBasePrices();
    window.n7ptBindEvents();
    window.n7ptSetupReadmore();
  };

  window.n7ptInit();
  document.addEventListener('DOMContentLoaded', function () { window.n7ptInit(); });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#n7-pfeifentabak-page')) {
      window.n7ptInit();
    }
  });

}());